import {Box, Button, Typography} from '@mui/material';
import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {adminDeleteTeamSession} from '../../api/teamSessionAPI';
import {useNavigate, useParams} from 'react-router-dom';

interface Props {
  teamSessionId: number;
}

const DeleteTeamSession: React.FC<Props> = ({teamSessionId}) => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {teamId} = useParams();

  const [deleteInProgress, setDeleteInProgress] = useState(false);

  const handleDelete = useCallback(async () => {
    setDeleteInProgress(true);
    const confirmed = window.confirm(
      t('admin.deleteTeamSessionConfirm') as string,
    );
    if (confirmed) {
      const res = await adminDeleteTeamSession(teamSessionId);
      if (!res?.success) {
        window.alert(res?.error ?? t('admin.failedToDeleteTeamSession'));
        setDeleteInProgress(false);
        return;
      }

      // redirect to team sessions page
      navigate(`/teams/${teamId}/teamsessions`);
    }
  }, [t, teamSessionId, teamId, navigate]);

  return (
    <Box sx={{my: 2}}>
      <Typography variant="h4" sx={{mb: 2}}>
        {t('admin.deleteTeamSession')}
      </Typography>
      <Button
        variant="outlined"
        disabled={deleteInProgress}
        onClick={handleDelete}>
        {t('general.delete')}
      </Button>
    </Box>
  );
};

export default DeleteTeamSession;
